import React, { useEffect, useState } from "react";
import { useField } from "formik";
import "./General-Text-Input.css";

// Create a text box with error detection using Formik hooks
export const GeneralTextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    const [validationCheck, setValidationCheck] = useState("");

    // Sets up bootstrap validation styling
    useEffect(() => {
        if (meta.touched && meta.error) {
            setValidationCheck("is-invalid");
        } else if (meta.touched && !meta.error) {
            setValidationCheck("is-valid");
        }
    }, [meta.touched, meta.error]);

    return (
        <>
            <div className="form-row">
                <label
                    className=" label px-0 mx-0"
                    htmlFor={props.id || props.name}
                >
                    {label}
                </label>
                <input
                    {...field}
                    {...props}
                    className={"form-control" + " " + validationCheck}
                />
            </div>
            {meta.touched && meta.error ? (
                <div>
                    <p className="invalid-feedback">{meta.error}</p>
                </div>
            ) : null}
        </>
    );
};
